export default "__VITE_PUBLIC_ASSET__73a2b644__"